import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIPublic } from '@/proxy-web';

function cancelWebBooking(bookingId: string) {
  return getSMPBackendAPIPublic().requestControllerConfirmCancelRequestV1(bookingId);
}

export function useCancelWebBooking() {
  return useMutation({ mutationFn: cancelWebBooking });
}
